import moment from "moment";

const BASE_URL = "https://calendar.google.com/calendar/render";

interface CalendarEventParams {
    text: string;
    start: string | Date;
    end: string | Date;
    url?: string;
    details?: string;
}

const generateGoogleCalendarEvent = ({text, start, end, url, details = "",}: CalendarEventParams): string => {
    const startDate = moment(start).utc().format("YYYYMMDD[T]HHmmss[Z]");
    const endDate = moment(end).utc().format("YYYYMMDD[T]HHmmss[Z]");

    return `${BASE_URL}?action=TEMPLATE&text=${encodeURIComponent(
        text
    )}&dates=${startDate}/${endDate}&details=${encodeURIComponent(
        details || `More info: ${url}`
    )}`;
};

const generateOutlookEvent = ({text, start, end, url, details = "",}: CalendarEventParams): string => {
    const startDate = moment(start).utc().format("YYYY-MM-DDTHH:mm:ss");
    const endDate = moment(end).utc().format("YYYY-MM-DDTHH:mm:ss");

    return `https://outlook.live.com/calendar/0/deeplink/compose?subject=${encodeURIComponent(
        text
    )}&startdt=${startDate}&enddt=${endDate}&body=${encodeURIComponent(
        details || `More info: ${url}`
    )}&location=${encodeURIComponent(url || "")}`;
};

const generateAppleEvent = ({
                                       text,
                                       start,
                                       end,
                                       url,
                                       details = "",
                                   }: CalendarEventParams): string => {
    const startDate = moment(start).utc().format("YYYYMMDDTHHmmss[Z]");
    const endDate = moment(end).utc().format("YYYYMMDDTHHmmss[Z]");

    const icsContent = `
BEGIN:VCALENDAR
VERSION:2.0
CALSCALE:GREGORIAN
BEGIN:VEVENT
SUMMARY:${text}
DTSTART:${startDate}
DTEND:${endDate}
DESCRIPTION:${details || `More info: ${url}`}
URL:${url || ""}
LOCATION:${url || ""}
STATUS:CONFIRMED
SEQUENCE:0
END:VEVENT
END:VCALENDAR
`;

    return `data:text/calendar;charset=utf-8,${encodeURIComponent(icsContent.trim())}`;
};


export {
    generateGoogleCalendarEvent,
    generateOutlookEvent,
    generateAppleEvent
}
